module.exports = __webpack_public_path__ + "67b7dac0b3b281c9adf110fe80c62215.jpg";